<template>
  <div class="address-new">
    <span class="back" @click="goBack"><i class="i_vip"></i></span>
    <form>
      <div class="form-item">
        <p class="title">姓名：</p>
        <input type="text" placeholder="请输入姓名" v-model="name" />
      </div>
      <div class="form-item">
        <p class="title">电话：</p>
        <input
          type="tel"
          placeholder="请输入电话"
          maxlength="11"
          v-model="mobile"
        />
      </div>
      <div class="form-item" @click="showAreaSelector">
        <p class="title">省-市-区：</p>
        <input
          type="text"
          placeholder="请选择省市区"
          readonly="true"
          v-model="pcd"
        />
      </div>
      <div class="form-item">
        <p class="title">详细地址：</p>
        <textarea
          type="text"
          placeholder="请输入详细地址"
          v-model="address"
        ></textarea>
      </div>
    </form>
    <area-selector
      class="area-select"
      :province.sync="selector.province"
      :city.sync="selector.city"
      :county.sync="selector.district"
      value="所在地区"
      :isShowAreaSelector.sync="isShowAreaSelector"
      :cancel-handler="hideSelectorHandler"
      :confirmHandler="confirmSelectorHandler"
      v-if="isShowAreaSelector"
    />
    <div class="button" @click="updateAddress">确认地址</div>
  </div>
</template>

<script>
import areaSelector from "../../components/dumb/AreaSelector";
import { isEmptyStr, isValidPhone } from "@/utils/utils";
import utils from "@/assets/js/utils";
import ajax from "@/api/memberAjax";

const token = utils.getQueryString("token");
const version = utils.getQueryString("version");
const source = utils.getQueryString("source");

export default {
  components: { areaSelector },
  data() {
    return {
      name: "",
      mobile: "",
      address: "",
      selector: {
        province: "",
        city: "",
        district: "",
      },
      isShowAreaSelector: false,
    };
  },

  computed: {
    pcd: function () {
      const { province, city, district } = this.selector;
      return `${province} ${city} ${district}`;
    },
  },

  methods: {
    showAreaSelector() {
      this.isShowAreaSelector = true;
    },

    hideSelectorHandler() {
      this.isShowAreaSelector = false;
    },

    confirmSelectorHandler(region, json) {
      this.selector = json;
      this.isShowAreaSelector = false;
    },

    checkValidate() {
      if (isEmptyStr(this.name)) {
        this.$toast("请正确填写姓名！");
        return false;
      }
      if (!isValidPhone(this.mobile)) {
        this.$toast("请正确填写电话！");
        return false;
      }
      if (
        isEmptyStr(this.selector.province) ||
        isEmptyStr(this.selector.city) ||
        isEmptyStr(this.selector.district)
      ) {
        this.$toast("请正确填写省市区！");
        return false;
      }
      if (isEmptyStr(this.address)) {
        this.$toast("请正确填写地址！");
        return false;
      }

      return true;
    },

    async getAddress() {
      let resp = await ajax.get(
        "/pay/return-money/get-logistics-progress?timestamp=" + Date.now(),
        {
          params: { token, version, source },
        }
      );

      if (resp.config) resp = resp.data;

      if (resp.code == 99999) {
        resp = resp.data;
        this.name = resp.name;
        this.mobile = resp.mobile;
        this.address = resp.address;
        this.selector.province = resp.province;
        this.selector.city = resp.city;
        this.selector.district = resp.district;
      } else {
        this.$toast(resp.msg);
      }
    },

    async updateAddress() {
      if (!this.checkValidate()) return;
      let timestamp = Date.parse(new Date());
      let resp = await ajax.post("/pay/return-money/update-address", {
        token,
        source,
        version,
        name: this.name,
        mobile: this.mobile,
        province: this.selector.province,
        city: this.selector.city,
        district: this.selector.district,
        address: this.address,
        timestamp,
      });
      if (resp.config) resp = resp.data;
      if (resp.code === 99999) {
        let timestamp = Date.parse(new Date());
        this.$router.push({
          path:
            "/card/logistics?version=" +
            version +
            "&token=" +
            token +
            "&source=" +
            source +
            "&random" +
            timestamp,
        });
      } else {
        this.$toast(resp.msg);
      }
    },

    goBack() {
      let timestamp = Date.parse(new Date());
      this.$router.push({
        path:
          "/card/logistics?version=" +
          version +
          "&token=" +
          token +
          "&source=" +
          source +
          "&random" +
          timestamp,
      });
    },
  },

  mounted() {
    this.getAddress();
  },
};
</script>

<style lang="scss">
@import "./area.sass";
@import "./address.sass";

.address-new {
  background-color: #fff;
  height: 100vh;
  padding: 1rem 0.44rem 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .title {
    color: #111f2c;
    font-size: 0.36rem;
    line-height: 0.5rem;
    margin-left: 0.32rem;
    margin-bottom: 0.1rem;
  }

  input {
    display: block;
    width: 100%;
    height: 0.88rem;
    background-color: #f2f4f5;
    border-radius: 0.14rem;
    padding: 0.2rem 0.32rem;
  }
  textarea {
    display: block;
    width: 100%;
    background-color: #f2f4f5;
    border-radius: 0.14rem;
    padding: 0.2rem 0.32rem;
    height: 2.24rem;
    outline: none;
    border-color: transparent;
    resize: none;
  }
  .form-item {
    margin-bottom: 0.5rem;
  }
  .button {
    // position: fixed;
    width: 6.7rem;
    height: 0.88rem;
    border-radius: 0.44rem;
    background-color: #ff571d;
    color: #fff;
    font-size: 0.3rem;
    font-weight: bold;
    text-align: center;
    line-height: 0.88rem;
    // bottom: .5rem;
  }

  .back {
    display: inline-block;
    position: absolute;
    left: 0.2rem;
    top: 0.3rem;
    padding: 0 0.2rem;
    i {
      display: inline-block;
      width: 0.19rem;
      height: 0.19rem;
      border-left: 0.02rem solid rgba(0, 0, 0, 0.8);
      border-top: 0.02rem solid rgba(0, 0, 0, 0.8);
      transform: rotate(-45deg);
    }
    .i_vip {
      border-left: 0.02rem solid #42301b;
      border-top: 0.02rem solid #42301b;
    }
  }
}
</style>